export default {"src":"/a/r/be1.10/_next/static/media/destination.cecc1045.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};